const ONLY_NUMBERS_REGEX = /^\d+$/

export const extractFromUrl = (urlParts: string[]) => {
  switch (urlParts.length) {
    case 1:
      if (ONLY_NUMBERS_REGEX.test(urlParts[0])) {
        // pattern is /<docId>
        return { docId: urlParts[0] }
      }
      return {}

    case 2:
      if (ONLY_NUMBERS_REGEX.test(urlParts[1])) {
        // pattern is /<slug>/<docId>
        return { slug: urlParts[0], docId: urlParts[1] }
      }
      if (ONLY_NUMBERS_REGEX.test(urlParts[0])) {
        // pattern is /<docId>/<slug>
        return { docId: urlParts[0], slug: urlParts[1] }
      }
      return {}

    default:
      return {}
  }
}
